/** 
THIS FILE IS AUTOGENERATED
weeeeeeeeeee
steps --> 
1) Download Figma Theme Tokens from starter project in Figma via Design Tokens plugin.
2) Replace design-tokens.tokens.json with the new file.
3) In your console, run: yarn generate-token-json.
*/

// THEME BOILERPLATE VALUES
const sharedThemeValues = {
  typography: {
    heading1: {
      fontSize: 48.83000183105469,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 58.596,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
    heading2: {
      fontSize: 39.060001373291016,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 46.872,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
    heading3: {
      fontSize: 31.25,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 37.5,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
    heading4: {
      fontSize: 25,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 30,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
    heading5: {
      fontSize: 20,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 24,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
    paragraph: {
      fontSize: 16,
      textDecoration: "none",
      fontFamily: "Inter",
      fontWeight: 400,
      fontStyle: "normal",
      fontStretch: "normal",
      letterSpacing: 0,
      lineHeight: 19.2,
      paragraphIndent: 0,
      paragraphSpacing: 0,
      textCase: "none",
    },
  },
  spacing: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64],
};
const themeShape = {
  colors: {
    background: "#e5e7ebff",
    surface: "#f3f4f6ff",
    onsurface: "#111827ff",
    onbackground: "#111827ff",
    primary: "#3730a3ff",
    onprimary: "#f9fafbff",
    primaryhover: "#3f40c2ff",
    primaryactive: "#312e81ff",
    surfacehover: "#d1d5dbff",
    surfaceactive: "#9ca3afff",
    primarydisabled: "#4b5563ff",
    surfacedisabled: "#6b7280ff",
    gray50: "#f9fafbff",
    gray100: "#f3f4f6ff",
    gray200: "#e5e7ebff",
    gray300: "#d1d5dbff",
    gray400: "#9ca3afff",
    gray500: "#6b7280ff",
    gray600: "#4b5563ff",
    gray700: "#374151ff",
    gray800: "#1f2937ff",
    gray900: "#111827ff",
    indigo50: "#eff3feff",
    indigo100: "#e0e7ffff",
    indigo300: "#a5b4fcff",
    indigo400: "#818cf8ff",
    indigo500: "#6366f1ff",
    indigo600: "#4f46e5ff",
    indigo700: "#3f40c2ff",
    indigo800: "#3730a3ff",
    indigo900: "#312e81ff",
  },
  ...sharedThemeValues,
};
export const primitiveColors = {
  gray50: "#f9fafbff",
  gray100: "#f3f4f6ff",
  gray200: "#e5e7ebff",
  gray300: "#d1d5dbff",
  gray400: "#9ca3afff",
  gray500: "#6b7280ff",
  gray600: "#4b5563ff",
  gray700: "#374151ff",
  gray800: "#1f2937ff",
  gray900: "#111827ff",
  indigo50: "#eff3feff",
  indigo100: "#e0e7ffff",
  indigo300: "#a5b4fcff",
  indigo400: "#818cf8ff",
  indigo500: "#6366f1ff",
  indigo600: "#4f46e5ff",
  indigo700: "#3f40c2ff",
  indigo800: "#3730a3ff",
  indigo900: "#312e81ff",
};
export const themeSpecificColorsKeys = [
  "background",
  "surface",
  "onsurface",
  "onbackground",
  "primary",
  "onprimary",
  "primaryhover",
  "primaryactive",
  "surfacehover",
  "surfaceactive",
  "primarydisabled",
  "surfacedisabled",
];
export const themeTypographyKeys = [
  "heading1",
  "heading2",
  "heading3",
  "heading4",
  "heading5",
  "paragraph",
];

// TYPES
export type TThemeColorKey = keyof typeof themeShape.colors;
export type TThemeTypographyKey = keyof typeof themeShape.typography;
export type TThemeTypographyVariant = typeof themeShape.typography.heading1;

export type TTheme = typeof themeShape;

// THEMES
export const lightTheme: TTheme = {
  colors: {
    background: "#e5e7ebff",
    surface: "#f3f4f6ff",
    onsurface: "#111827ff",
    onbackground: "#111827ff",
    primary: "#3730a3ff",
    onprimary: "#f9fafbff",
    primaryhover: "#3f40c2ff",
    primaryactive: "#312e81ff",
    surfacehover: "#d1d5dbff",
    surfaceactive: "#9ca3afff",
    primarydisabled: "#4b5563ff",
    surfacedisabled: "#6b7280ff",
    gray50: "#f9fafbff",
    gray100: "#f3f4f6ff",
    gray200: "#e5e7ebff",
    gray300: "#d1d5dbff",
    gray400: "#9ca3afff",
    gray500: "#6b7280ff",
    gray600: "#4b5563ff",
    gray700: "#374151ff",
    gray800: "#1f2937ff",
    gray900: "#111827ff",
    indigo50: "#eff3feff",
    indigo100: "#e0e7ffff",
    indigo300: "#a5b4fcff",
    indigo400: "#818cf8ff",
    indigo500: "#6366f1ff",
    indigo600: "#4f46e5ff",
    indigo700: "#3f40c2ff",
    indigo800: "#3730a3ff",
    indigo900: "#312e81ff",
  },
  ...sharedThemeValues,
} as const;
export const darkTheme: TTheme = {
  colors: {
    onbackground: "#f9fafbff",
    onprimary: "#f9fafbff",
    onsurface: "#f9fafbff",
    primary: "#3730a3ff",
    surface: "#374151ff",
    background: "#111827ff",
    surfacehover: "#4b5563ff",
    primaryhover: "#3f40c2ff",
    primaryactive: "#312e81ff",
    surfaceactive: "#1f2937ff",
    primarydisabled: "#4b5563ff",
    surfacedisabled: "#6b7280ff",
    gray50: "#f9fafbff",
    gray100: "#f3f4f6ff",
    gray200: "#e5e7ebff",
    gray300: "#d1d5dbff",
    gray400: "#9ca3afff",
    gray500: "#6b7280ff",
    gray600: "#4b5563ff",
    gray700: "#374151ff",
    gray800: "#1f2937ff",
    gray900: "#111827ff",
    indigo50: "#eff3feff",
    indigo100: "#e0e7ffff",
    indigo300: "#a5b4fcff",
    indigo400: "#818cf8ff",
    indigo500: "#6366f1ff",
    indigo600: "#4f46e5ff",
    indigo700: "#3f40c2ff",
    indigo800: "#3730a3ff",
    indigo900: "#312e81ff",
  },
  ...sharedThemeValues,
} as const;
